import { createContext } from 'react';

export interface BindContext {
  submitBind(): Promise<void>;
}

export const BindContext = createContext<BindContext>({
  submitBind: () => Promise.resolve(),
});
